export enum UnplannedPregnancyTrigger {
  GOAL = 'goal',
  PREG_TEST = 'preg_test',
}
